import axios from 'axios';

//instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;
export class Transport {
  token = '';
  server;
  logic;

  /**
   * set interceptors
   */
  constructor({ apiUrl, logic, timeout = 50000 }) {
    this.logic = logic;
    this.server = axios.create({
      baseURL: apiUrl,
      timeout: timeout,
      headers: {},
    });

    this.server.interceptors.request.use(logic.prepareRequest, logic.prepareError);
    this.server.interceptors.response.use(logic.prepareResponse, logic.prepareError);
  }

  logout = () => {
    this.logic.logout();
  };

  getToken = () => {
    return this.logic.getToken();
  };

  async call(method, params = {}, type = 'post') {
    switch (type) {
      default:
      case 'post':
        return await this.server.post(method, params);
      case 'put':
        return await this.server.put(method, params);
      case 'delete':
        return await this.server.delete(method, params);
      case 'get':
        return await this.server.get(method, params);
    }
  }

  async get(method, params = {}) {
    return await this.call(method, { params: params }, 'get');
  }

  async post(method, params = {}) {
    return await this.call(method, params);
  }

  async put(method, params = {}) {
    return await this.call(method, params, 'put');
  }

  async delete(method, params = {}) {
    return await this.call(method, params, 'delete');
  }
}
